import { Observable, Subject, of } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  AssignmentTemplateNotificationItem,
  AssignmentTemplateNotificationItemContext
} from '../models/assignment-template-notification-item';
import { NotificationService } from './notification-service';
import { AssignmentTemplateNotificationServiceConfig } from '../interfaces/assignment-template-notification-service-config';

// this class is the base interface of services used by the aggregated-notification-service for the notification indicator
export class AssignmentTemplateNotificationService extends NotificationService {
  notificationStream: Observable<AssignmentTemplateNotificationItem> = new Subject<AssignmentTemplateNotificationItem>();

  type: string = AssignmentTemplateNotificationItem.NOTIFICATION_SUBTYPE;
  config: AssignmentTemplateNotificationServiceConfig;
  context: AssignmentTemplateNotificationItemContext;

  constructor(setup: AssignmentTemplateNotificationServiceConfig) {
    super(setup);
    this.config = setup;
  }

  markAsRead(items: AssignmentTemplateNotificationItem[]): Observable<any> {
    return of({}); //these notifications stick around until the teacher creates the assignment
  }

  markAsSeen(items: AssignmentTemplateNotificationItem[]): Observable<any> {
    return of({}); //these notifications stick around until the teacher creates the assignment
  }

  initializeNotificationStream(): Observable<any> {
    return of({}); //real time notifications are not needed here for now
  }

  getRecentNotifications(limit: number): Observable<AssignmentTemplateNotificationItem[]> {
    return this.config.getNotifications.pipe(
      map(
        (notificationRIs) => {
          return notificationRIs.map((ri) => {
            return new AssignmentTemplateNotificationItem(
              {
                postedAt: ri.postedAt,
                assignmentTemplateUid: ri.assignmentTemplateUid,
                assignmentName: ri.assignmentName,
                sectionUid: ri.sectionUid,
                sectionName: ri.sectionName,
                hasBeenAssigned: ri.hasBeenAssigned,
                needsReassignment: ri.needsReassignment,
                assignmentUid: ri.assignmentUid
              }
            );
          });
        })
    );
  }
}
